module.exports = __webpack_public_path__ + "static/media/plan-TH3-mobile-sc.e37f7cde.png";